// eslint-disable-next-line max-classes-per-file
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { AzureKeyVaultActivity } from 'app/model/pipeline/akv.activity';
import _ from 'lodash';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureKeyVaultActivity),
    asynchronous: true,
    adapts: {
        name: '*',
        description: '*',
        type: '*',
        linkedServiceName: '*',
        policy: '*',
        dependsOn: '*',
        userProperties: '*',
        typeProperties: {
            inputs: '*'
        }
    }
})
export class AzureKeyVaultActivityAdapter {
    
}
